import { Content, ContentDetail, TranslationWord } from "./globalType";
import translation from "./translations.json";

const numeral = require('numeral')

export function displayDuration(duration:number | undefined) {
  if (!duration) return '-'
  if(duration < 60) return `${duration} นาที`

  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;

  let result = `${hours} ช.ม.`
  if (minutes > 0)
    result += ` ${minutes} นาที`

  return result
}

export function displayNumber(value: number | undefined) {
  if (!value) return '-'

  return numeral(value).format('0,0')
}

export function share(platformUrl: string,shareUrl:string) {
  const url = `${platformUrl}${shareUrl}`
  window.open(url, '_blank');
}

export function getContentUrl(content:Content | ContentDetail | null) {
  if (!content) return window.location.href
  if (content.movie_type === 'series') {
    return `https://movie.trueid.net/th-th/series/${content.id}`
  } else if (content.movie_type === 'movie') {
    return `https://movie.trueid.net/th-th/movie/${content.id}`
  }
  return window.location.href
}

export function getSportUrl(id:string) {
  if (!id) return window.location.href

  return `https://sport.trueid.net/detail/${id}`
}

export function translate(th:String | null | undefined | string, en:String|null|undefined | string, lang:String | undefined) {
  if (lang === 'en' && en) return en
  return th
}

export function translate2(th:string, en:string, lang:String | undefined) {
  if (lang === 'en' && en) return en
  return th
}

export function translateByKey(word: TranslationWord, lang: String | undefined) {
  if (!word) return ''
  if (lang === 'en' && word.en) return word.en
  return word.th
}

export function translateDefault(th:String | null | undefined | string, en:String|null|undefined | string, lang:String | undefined, defaultText: string) {
  if (lang === 'en' && en) return en
  if (!th) return defaultText
  return th
}

export function getHost() {
  let domain = window.location.hostname
  if (domain !== 'localhost') {
    //domain = 'cms-truevisions.tanawat.dev'
    domain = "cms.truevisions.co.th"
  }
  let host = `${window.location.protocol}//${domain}`
  if (window.location.port !== '80' && window.location.port !== '443') {
    host += `:${window.location.port}`
  }

  return host
}